/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUserLocation: {
  name: 'user-location';
  data: string;
} = {
  name: 'user-location',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM5 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm14-2a1 1 0 0 0-1 1c0 .809.485 1.722 1 2.437.515-.715 1-1.628 1-2.437a1 1 0 0 0-1-1Zm-3 1a3 3 0 1 1 6 0c0 1.592-.954 3.06-1.557 3.848a1.804 1.804 0 0 1-2.886 0C16.954 9.061 16 7.592 16 6ZM4 20a5 5 0 0 1 10 0 1 1 0 1 0 2 0 7 7 0 1 0-14 0 1 1 0 1 0 2 0Z" fill="currentColor"/></svg>`,
};
